<!--
component: BrowseBuilding2men-2
author: Ken Nakamura
description: 建築計画概要書（第二面その２）
-->
<template>
  <section class="A4">
    <p style="font-size: 9pt;">
      注：この建築計画概要書は申請時に提出された原本ではなく、入力データから再構築したものです。
    </p>
    <div v-show="nobemenVisible">
      <BrowseBuildingNobemen :gaiyo="gaiyo" />
      <hr>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【12.建築物の数】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.申請に係る建築物の数】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">{{gaiyo.gaiyoRec.snS_BLD_SU}}</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.同一敷地内の他の建築物の数】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">{{gaiyo.gaiyoRec.kizoN_BLDNG_SU}}</div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【13.建築物の高さ等】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-header item-1">申請に係る建築物</div>
        <div class="gaiyo-header item-2">他の建築物</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.最高の高さ】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">{{fmtm(gaiyo.gaiyoRec.snS_BLD_HEIGHT, 3)}} ｍ</div>
        <div class="gaiyo-item item-2">{{fmtm(gaiyo.gaiyoRec.etC_BLD_HEIGHT, 3)}} ｍ</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.階数】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-40">地上</div>
        <div class="gaiyo-item item-1">{{gaiyo.gaiyoRec.snS_BLD_TIJO_KAISU}} 階</div>
        <div class="gaiyo-item item-2">{{gaiyo.gaiyoRec.etC_BLD_TIJO_KAISU}} 階</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-40">地下</div>
        <div class="gaiyo-item item-1">{{gaiyo.gaiyoRec.snS_BLD_TIKA_KAISU}} 階</div>
        <div class="gaiyo-item item-2">{{gaiyo.gaiyoRec.etC_BLD_TIKA_KAISU}} 階</div>
      </div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾊ.構造】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-40">
          {{getKozo(gaiyo.gaiyoRec.kozO_SYBT)}}（{{gaiyo.gaiyoRec.gutaI_KOZO_SYBT}}）
        </div>
      </div>
      <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.gutaI_KOZO_SYBT,34)" :key="`gutaikozo-${index}`">
        <br v-show="index>0">
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾆ.建築基準法第56条第7項の規定による特例の適用の有無】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-120"><Checkbox :checked="gaiyo.gaiyoRec.tokureI_UMU==1" caption="有" /></div>
        <div class="gaiyo-element left-130"><Checkbox :checked="gaiyo.gaiyoRec.tokureI_UMU!=1" caption="無" /></div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾎ.適用があるときは、特例の区分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-item item-0"><Checkbox caption="道路高さ制限不適用" :checked="gaiyo.tokurei1" /></div>
        <div class="gaiyo-item item-1"><Checkbox caption="隣地高さ制限不適用" :checked="gaiyo.tokurei2" /></div>
        <div class="gaiyo-item item-2"><Checkbox caption="北側高さ制限不適用" :checked="gaiyo.tokurei3" /></div>
      </div>
      <br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【14.許可・認定等】</div>
    </div>
    <div v-for="(k, index) in gaiyo.kyokaNintei" :key="`a-${index}`"
      class="gaiyo-row">
      <!--
      <div class="gaiyo-element left-10">
        {{k.horei}} {{k.joko}} {{k.kyokA_NO}} {{dateTextToWareki(k.kyokA_DAY)}}
      </div>
      -->
      <!--
      <div v-for="(lin, index) in fmt_kyokanintei(k)" :key="`b-${index}`"
        class="gaiyo-row">
        <div class="gaiyo-element left-10">
          {{lin}}
        </div><br>
      </div>
      -->
      <!---->
      <div class="gaiyo-row">
        <div class="gaiyo-element left-10 kyokanintei">
          {{fmt_kyokanintei(k)}}
        </div>
        <div v-for="(n,index) in wordwrap(fmt_kyokanintei(k),60)" :key="`kyokanintei-${index}`">
          <br v-show="index>0"></div>
        <br>
      </div>
      <!---->
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【15.工事着手予定年月日】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-header item-1">{{dateTextToWareki(gaiyo.gaiyoRec.worK_START_PRG_DAY)}}</div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【16.工事完了予定年月日】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-header item-1">{{dateTextToWareki(gaiyo.gaiyoRec.worK_KNRY_PRG_DAY)}}</div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【17.特定工程工事終了予定年月日】</div>
    </div>
    <div v-for="(t, index) in gaiyo.tokuteiKotei" :key="`b-${index}`"
      style="padding:0;">
      <div class="gaiyo-row" v-show="index<6">
        <div class="gaiyo-element left-05">(第 {{t.worK_NO}} 回)</div>
        <div class="gaiyo-element left-20">&nbsp;&nbsp;{{dateTextToWareki(t.worK_DAY)}}</div>
        <div v-for="(name,index) in wordwrap(t.worK_NAME,34)" :key="`sp-${index}`">
          <div class="gaiyo-element left-55">{{name}}</div><br>
        </div>
      </div>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【18.建築基準法第１２条第１項の規定による調査の要否】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-10"><Checkbox caption="要" :checked="gaiyo.gaiyoRec.chousa_youhi==1" /></div>
        <div class="gaiyo-element left-30"><Checkbox caption="否" :checked="gaiyo.gaiyoRec.chousa_youhi==0" /></div>
      </div>
      <br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【19.建築基準法第１２条第３項の規定による検査を要する防火設備の有無】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-10"><Checkbox caption="有" :checked="gaiyo.gaiyoRec.boukA_UMU==1" /></div>
        <div class="gaiyo-element left-30"><Checkbox caption="無" :checked="gaiyo.gaiyoRec.boukA_UMU==0" /></div>
      </div>
      <br>
    </div>
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【20.建築基準法施行令第43条第1項及び第46条第4項等に係る経過措置の適用】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.適用の有無】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-40"><Checkbox :checked="gaiyo.gaiyoRec.keikA_SOCHI_UMU==1" caption="有" /></div>
        <div class="gaiyo-element left-50"><Checkbox :checked="gaiyo.gaiyoRec.keikA_SOCHI_UMU!=1" caption="無" /></div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.適用があるときは、その区分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-10">
        <Checkbox caption="建築基準法施行令第43条第1項及び第46条第4項" :checked="gaiyo.keikaSochi1" />
      </div>
      <br>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-element left-10">
        <Checkbox caption="その他" :checked="gaiyo.keikaSochi2" />
      </div>
      <br>
    </div>
    
    <hr>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【21.その他必要な事項】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-10">
          {{gaiyo.gaiyoRec.etC_JIKO}}
        </div>
      </div>
      <br>
    </div>
  </section>
</template>

<script>
import { wordwrap } from '../common/utils';
import BrowseBuildingNobemen from '../components/building/BrowseBuildingNobemen.vue';
import Checkbox from '../components/Checbox.vue';
import constants from '../common/constants';

export default {
  components: {
    BrowseBuildingNobemen,
    Checkbox,
  },
  props: {
    nobemenVisible: {
      type: Boolean,
      default: () => false
    },
    gaiyo: {
      type: Object,
      default: null
    },
  },
  computed: {
  },
  methods: {
    getKozo(code) {
      try {
        if (code !== undefined && code !== null)
          return constants.kozoKubun[code].name;
        else
          return '';
      }
      catch (err) {
        console.log(err);
        return '';
      }
    },
    fmt(val, prec) {
      const v = (val == null) ? 0 : val;
      return v.toFixed(prec);
    },
    fmtm(val, prec) {
      const v = (val == null) ? 0 : val;
      return (v / 1000).toFixed(prec);
    },
    dateTextToWareki(date) {
      if (date) {
        const year = date.substr(0, 4);
        const month = date.substr(5, 2);
        const day = date.substr(8, 2);
        date = new Date(year, month - 1, day);
        return new Intl.DateTimeFormat(
          'ja-JP-u-ca-japanese',
          {
            era: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }
        ).format(date);
      }
      else {
        return '';
      }
    },
    wordwrap(text, len) {
      /*
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      else {
        result.push('');
      }
      return result;
      */
      return wordwrap(text, len);
    },
    fmt_kyokanintei(k) {
      let lin = '';
      if (k.horei) {
        lin += k.horei;
      }
      if (k.joko) {
        if (lin.length)
          lin += '　';
        lin += k.joko;
      }
      if (k.kyokA_NO) {
        if (lin.length)
          lin += '　';
        lin += k.kyokA_NO;
      }
      if (k.kyokA_DAY) {
        if (lin.length)
          lin += '　';
        lin += this.dateTextToWareki(k.kyokA_DAY);
      }
      //return this.wordwrap(lin, 54);
      //return this.wordwrap(lin, 49);
      return lin;
    }
  }
}
</script>

<style lang="scss">
</style>